import { Route, Routes } from "react-router-dom";
import { Routes as ReportRoutes } from "./routes";
import { ReportRouterCmp } from "./types";
import { ReportSearchPage } from "../pages";
import { ReportPage } from "../pages/ReportPage";
import { FinancialOverviewPage } from "../pages/FinancialOverviewPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ReportRouter: ReportRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={ReportSearchPage.route} element={<ReportSearchPage />} />
        <Route path={ReportPage.route} element={<ReportPage />} />
        <Route
          path={FinancialOverviewPage.route}
          element={<FinancialOverviewPage />}
        />
      </Routes>
    </>
  );
};

ReportRouter.route = ReportRoutes.ReportRouter;

export default ReportRouter;
